/* eslint-disable react/prop-types */
// @flow
import { NetworkMap } from 'esm-web-pro/routes/Network';
import CoverageMap from 'esm-web-pro/routes/CoverageMap';
import React from 'react';
import { Box, Grommet } from 'grommet';
import theme from 'esm-web-pro/styles/theme';
import { Default } from 'esm-web-pro/components/layout';
import { MessageDialogs } from 'esm-web-pro/containers';
import { Route } from 'react-router';
import ReactTooltip from 'react-tooltip';
import { ConfirmActions, getUser } from 'speed-js-react';
import { NetworkIndicator } from 'speed-js-react-web';
import SidePaneContainer from 'esm-web-pro/components/layout/SidePaneContainer';
import ConfirmBeforeUnloadWithSensitivePanel from
    'esm-web-pro/components/dialogs/ConfirmBeforeUnloadWithSensitivePanel';
import projectsRoutes from 'esm-web-pro/routes/Projects';
import UserTasksProgress from 'esm-web-pro/containers/UserTasksProgress';
import ConfirmationActionsRenderer from 'esm-web-pro/components/dialogs/ConfirmationActionsRenderer';
import BottomShadow from 'esm-web-pro/components/layout/BottomShadow';
import styled from 'styled-components';
import Div100vh from 'react-div-100vh';
import RightShadow from 'esm-web-pro/components/layout/RightShadow';
import ConfirmBeforeUnloadWithCall from 'esm-web-pro/components/dialogs/ConfirmBeforeUnloadWithCall';
import WebNotificationsPermissionRequest from 'esm-web-pro/components/dialogs/WebNotificationsPermissionRequest';
import { useSelector } from 'react-redux';
import LandingPage from 'esm-web-pro/containers/pages/landing/LandingPage';
import ApiClientErrorHandler from 'esm-web-pro/components/ApiClientErrorHandler';
import getDocumentTitle from 'esm-web-pro/redux/documentTitle/selectors';
import { useIntl } from 'react-intl';
import * as Sentry from '@sentry/react';
import AdminPage from './components/pages/AdminPage';
import ErrorFallbackComponent from './components/dialogs/ErrorFallbackComponent';
import LandingTabController from './containers/pages/landing/LandingTabController';
import FocusedTabsController from './containers/panels/calling/FocusedTabsController';

const StyledGrommet = styled(Grommet)`
    height: 100%;
`;

const AppContainer = styled(Box)`
    width: 100%;
    height: 100%;
    overflow: auto;
    box-shadow: inset 10px 0px 10px -5px #b9b8b8, inset 0px 10px 10px -5px #dbdbdbeb;
`;

const App = () => {
    const user = useSelector(getUser);
    const documentTitle = useSelector(getDocumentTitle);
    const { formatMessage } = useIntl();

    React.useEffect(() => {
        document.title = process.env.REACT_APP_SYSTEM_TITLE;
        let title = '';
        if (documentTitle.documentTitle && typeof documentTitle.documentTitle === 'object') {
            if (documentTitle.documentTitle.id) {
                title = formatMessage(documentTitle.documentTitle);
            }
            if (documentTitle.documentTitle.props.id) {
                title = formatMessage(documentTitle.documentTitle.props);
            }
            if (documentTitle.documentTitle.props?.children?.props?.id) {
                title = formatMessage(documentTitle.documentTitle.props.children.props);
            }
        } else {
            title = documentTitle.documentTitle;
        }
        document.title = `${document.title} - ${title}`;
    }, [documentTitle.documentTitle, formatMessage]);

    return (
        <StyledGrommet full theme={theme}>
            <Div100vh>
                <LandingTabController />
                <FocusedTabsController />
                <ConfirmActions renderer={ConfirmationActionsRenderer}>
                    {/* There is no user -> display the landing tab so that the user can login */}
                    {user === null && <LandingPage />}
                    {user && (
                        <Default>
                            <WebNotificationsPermissionRequest />
                            <ConfirmBeforeUnloadWithSensitivePanel />
                            <ConfirmBeforeUnloadWithCall />
                            <Box direction="row" height="100%">
                                <SidePaneContainer>
                                    <AppContainer
                                        background="backgroundColor"
                                    >
                                        <Sentry.ErrorBoundary
                                            fallback={({ error, componentStack, resetError }) => (
                                                <ErrorFallbackComponent
                                                    error={error}
                                                    componentStack={componentStack}
                                                    resetError={resetError}
                                                />
                                            )}
                                        >
                                            <RightShadow>
                                                {CoverageMap}
                                                {NetworkMap}
                                                {projectsRoutes}
                                                <Route
                                                    path="/administration"
                                                    component={AdminPage}
                                                    exact={false}
                                                />
                                                <MessageDialogs />
                                                <ApiClientErrorHandler />
                                                <UserTasksProgress />

                                            </RightShadow>
                                            <BottomShadow />
                                        </Sentry.ErrorBoundary>

                                    </AppContainer>
                                    <ReactTooltip
                                        effect="solid"
                                        place="right"
                                        className="permission-required-tooltip"
                                    />
                                </SidePaneContainer>
                            </Box>
                        </Default>
                    )}
                </ConfirmActions>
                <NetworkIndicator />
            </Div100vh>
        </StyledGrommet>
    );
};

export default App;
